<template>
  <div
    class="offcanvas offcanvas-start"
    tabindex="-1"
    id="userPanel"
    aria-labelledby="userPanelLabel"
  >
    <div class="offcanvas-header">
      <h5 class="offcanvas-title text-center" id="userPanelLabel">
        Kullanıcı Bilgileri
      </h5>
      <button
        type="button"
        class="btn-close text-reset"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      ></button>
    </div>
    <div class="offcanvas-body">
      <div class="row">
        <p class="lead text-center mt-2">Hoşgeldiniz!</p>

        <div class="user-profile-picture" title="Profil resmini değiştir">
          <img :src="getProfilePicture" />
        </div>

        <p class="lead text-center">
          <strong>{{ getUserFullName }}</strong>
        </p>
        <p class="lead text-center">
          {{ getAccountTitle }}
        </p>
      </div>

      <hr />

      <div class="row justify-content-center">
        <div class="col-10">
          <div class="d-grid">
            <button class="btn btn-light btn-lg" type="button" @click="logout">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="36"
                height="36"
                fill="rgb(49 73 93)"
                class="bi bi-box-arrow-right me-3"
                viewBox="0 0 16 16"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                />
                <path
                  fill-rule="evenodd"
                  d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                />
              </svg>
              <span>Çıkış Yap</span>
            </button>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="d-grid">
          <span class="text-center text-muted">İzometri Bilişim © {{getYear()}}</span>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "User",
  computed: {
    login() {
      return this.$root.$data.login;
    },
    getUserFullName() {
      if (this.login)
        return `${this.login.User?.FirstName} ${this.login.User?.LastName}`;

      return "N/A";
    },
    getAccountTitle() {
      if (this.currentAccount) return this.currentAccount.Title;

      return "N/A";
    },
    currentAccount() {
      return this.$root.$data.login.Account;
    },
    
  },
  methods: {
    getYear(){
      var currentYear = new Date()
      return currentYear.getFullYear();
    },
    logout() {
      //if (!confirm("Oturumunuz sonlandırılacak.")) return;
      this.$izonayConfirm("Oturumu kapatmak istediğinize emin misiniz?").then(
        (response) => {
          if (!response.isConfirmed) return;

          var externalIdentitySource =
            this.$root?.$data?.login?.User.ExternalIdentitySource;

          axios.post("/token/signout", {});
          this.$root.$data.login = null;
          window.localStorage.removeItem("user");
          axios.defaults.headers.common["token"] = "";
          this.$store.commit("setUser", null);

          if (externalIdentitySource)
            this.logoutExternalUser(externalIdentitySource);
          else this.$router.push({ name: "Login" });
        }
      );
    },
    logoutExternalUser(externalIdentitySource) {
      const pushToLogin = () => {
        this.$router.push({ name: "Login" });
      };

      switch (externalIdentitySource) {
        case "Microsoft":
          this.$msalSignOut();
          break;
        case "ADFS":
          this.$msalSignOut(true);
          pushToLogin();
          break;
        default:
          pushToLogin();
      }
    },
  },
};
</script>
<style>
.user-profile-picture {
  cursor: pointer;
  margin: auto;
  padding: 0 !important;
  margin-top: 10px;
  margin-bottom: 20px;
  width: 100px;
  height: 100px;
  border-radius: 50px;
  overflow: hidden;
  box-shadow: 0px 0px 0px 8px rgba(0, 0, 0, 0.06);
}

.user-profile-picture img {
  width: 100px;
  height: 100px;
}

.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 60px;
  line-height: 60px;
}
</style>